var _excluded = ["disabled", "hideLabel", "hiddenLabel", "inputProps", "InputProps", "label", "readOnly", "required", "requiredText", "secondaryText", "size"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { InputAdornment, TextField as MuiTextField } from '@mui/material';
import { Danger as DangerIcon, CaretDown as CaretDownIcon } from '@mineral/icons';
import { getPropsWithPlaceholder } from '../Select';
import { Typography } from '../index';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TEST_ID_TEXT_FIELD_ERROR_ICON = 'textFieldErrorIcon';
export var TextField = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var disabled = _ref.disabled,
      hideLabel = _ref.hideLabel,
      hiddenLabel = _ref.hiddenLabel,
      inputProps = _ref.inputProps,
      InputProps = _ref.InputProps,
      label = _ref.label,
      readOnly = _ref.readOnly,
      required = _ref.required,
      _ref$requiredText = _ref.requiredText,
      requiredText = _ref$requiredText === void 0 ? 'Required' : _ref$requiredText,
      secondaryText = _ref.secondaryText,
      size = _ref.size,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded);

  var error = restProps.error,
      placeholder = restProps.placeholder,
      select = restProps.select,
      SelectProps = restProps.SelectProps;
  var ownerState = {
    hiddenLabel: hideLabel || hiddenLabel
  };
  return /*#__PURE__*/_jsx(MuiTextField, _extends({
    hiddenLabel: hideLabel || hiddenLabel
  }, select && !(SelectProps != null && SelectProps["native"]) && placeholder ? getPropsWithPlaceholder(restProps) : restProps, {
    disabled: disabled,
    inputProps: _extends({
      readOnly: readOnly,
      required: required
    }, inputProps),
    InputProps: _extends({
      // @ts-ignore - Doesn't recognize data attributes
      'data-readonly': readOnly != null ? readOnly : undefined
    }, InputProps, {
      endAdornment: error ? /*#__PURE__*/_jsx(InputAdornment, {
        position: "end",
        "data-testid": TEST_ID_TEXT_FIELD_ERROR_ICON,
        children: /*#__PURE__*/_jsx(DangerIcon, {
          color: "error"
        })
      }) : InputProps == null ? void 0 : InputProps.endAdornment
    }),
    label: (label || secondaryText || required) && /*#__PURE__*/_jsxs(_Fragment, {
      children: [label, (secondaryText || required) && /*#__PURE__*/_jsx(Typography, {
        variant: "caption",
        color: error || required ? 'error' : undefined,
        marginLeft: "auto",
        children: secondaryText || required && requiredText
      })]
    }),
    SelectProps: select ? _extends({
      IconComponent: CaretDownIcon,
      inputProps: _extends({
        // TODO: non-aria attributes would be better, but they wouldn't pass to the DOM?
        'aria-disabled': disabled,
        'aria-readonly': readOnly
      }, SelectProps == null ? void 0 : SelectProps.inputProps),
      SelectDisplayProps: _extends({
        'aria-disabled': disabled
      }, SelectProps == null ? void 0 : SelectProps.SelectDisplayProps)
    }, SelectProps, {
      size: size
    }) : SelectProps,
    size: size,
    variant: "outlined",
    ownerState: ownerState,
    ref: ref
  }));
});